import React, { useRef, useEffect } from 'react';
import naverMapIcon from '../images/naver.webp';
import kakaoMapIcon from '../images/kakao.png';
import { VENUE } from '../constants/wedding';

function Location() {
  const mapRef = useRef(null);
  const { lat, lng, name, address, directions, naverMapUrl, kakaoMapUrl, charterBus } = VENUE;

  useEffect(() => {
    const { naver } = window;
    if (mapRef.current && naver) {
      const location = new naver.maps.LatLng(lat, lng);
      const map = new naver.maps.Map(mapRef.current, {
        center: location,
        zoom: 15,
      });
      new naver.maps.Marker({
        position: location,
        map,
      });
    }
  }, [lat, lng]);

  const gotoNavermap = () => {
    if (naverMapUrl) {
      window.location.href = naverMapUrl;
    }
  };

  const gotoKakaomap = () => {
    if (kakaoMapUrl) {
      window.location.href = kakaoMapUrl;
    }
  };

  return (
    <div className='container'>
      <div className='title'>오시는 길</div>
      <div className='location__details'>
        <div>{name}</div>
        <div>{address}</div>
      </div>
      <div ref={mapRef} className='location__map'></div>
      <div className='location__map-icon-box'>
        <div className='location__map-item' onClick={gotoNavermap}>
          <img src={naverMapIcon} className='location__map-icon' alt="naverMap"/>
          <span>네이버지도</span>
        </div>
        <div className='location__map-item' onClick={gotoKakaomap}>
          <img src={kakaoMapIcon} className='location__map-icon' alt='kakaoMap'/>
          <span>카카오지도</span>
        </div>
      </div>
      <div className='location__info'>
        <div>{directions}</div>
      </div>
      <section className='location__bus' aria-labelledby='charter-bus-title'>
        <h2 id='charter-bus-title'>전세버스 안내</h2>
        <div className='location__bus-schedule'>
          <h3>예식장으로 오실 때</h3>
          <p>구미역 출발 → 터미널네거리 경유 → BW웨딩</p>
          <dl>
            {charterBus.outbound.map(({ stop, time }) => (
              <div key={stop}><dt>{stop} 출발</dt><dd>{time}</dd></div>
            ))}
          </dl>
        </div>
        <div className='location__bus-schedule'>
          <h3>예식 후 돌아가실 때</h3>
          <dl>
            {charterBus.returnTrip.map(({ stop, time }, index) => (
              <div key={stop}>
                <dt>{stop} {index === 0 ? '출발' : '도착'}</dt><dd>{time}</dd>
              </div>
            ))}
          </dl>
        </div>
        <div className='location__bus-boarding'>
          <h3>탑승 장소</h3>
          <dl>
            {charterBus.boardingLocations.map(({ stop, description }) => (
              <div key={stop}><dt>{stop}</dt><dd>{description}</dd></div>
            ))}
          </dl>
        </div>
        <p className='location__bus-operator'>운행사: {charterBus.operator}</p>
        <ul className='location__bus-notes'>
          {charterBus.notes.map((note) => <li key={note}>{note}</li>)}
        </ul>
        <a className='location__bus-link' href={charterBus.timetableUrl} target='_blank' rel='noopener noreferrer'>
          전세버스 시간표·탑승 장소 보기 ↗
        </a>
      </section>
    </div>
  );
}

export default Location;
